export interface User {
  id: number;
  full_name: string;
  email: string;
  role_id: number;
  role_name: string;
  birth_date?: string;
  phone?: string;
  is_active: boolean;
  shelter?: {
    shelterId: number;
    shelterName?: string;
    roleInShelter?: string;
  } | null;
}

export const saveAuthData = (token: string, user: User) => {
  sessionStorage.setItem('auth_token', token);
  sessionStorage.setItem('user_data', JSON.stringify(user));
};

export const getAuthToken = (): string | null => {
  return sessionStorage.getItem('auth_token');
};

export const getUser = (): User | null => {
  const userData = sessionStorage.getItem('user_data');
  return userData ? JSON.parse(userData) : null;
};

export const clearAuthData = () => {
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('user_data');
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};
